import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.iterator.some.js";
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5930b4e0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "ck-menu-section"
};
const _hoisted_2 = {
  class: "menu-item-label"
};
const _hoisted_3 = {
  class: "menu-badges"
};
const _hoisted_4 = {
  key: 0,
  class: "menu-new-badge"
};
const _hoisted_5 = {
  key: 1,
  class: "bx bxs-diamond gradient-icon"
};
const _hoisted_6 = {
  key: 0
};
const _hoisted_7 = {
  class: "menu-item-label"
};
const _hoisted_8 = {
  class: "menu-badges"
};
const _hoisted_9 = {
  key: 0,
  class: "menu-new-badge"
};
const _hoisted_10 = {
  key: 1,
  class: "bx bxs-diamond gradient-icon"
};
import { useStore } from 'vuex';
import { computed, onMounted, onUnmounted, ref } from 'vue';
import usePlanPrice from '@/composable/plan-price';
import { menuList } from '@/shared/constants/menu';
import { useRoute, useRouter } from 'vue-router';
import useLayouts from '@/composable/layout';
export default {
  __name: 'menu',
  setup(__props) {
    const {
      isCollapse,
      toggleSidebar
    } = useLayouts();
    const router = useRouter();
    const route = useRoute();
    const {
      currentPlan,
      setPlanPriceDialog
    } = usePlanPrice();
    const store = useStore();
    const userRole = computed(() => permission => {
      return store.getters['auth/hasPermission'](permission);
    });
    function handleClickProFeature(path, code = '') {
      if (!code) router.push(path);else {
        let isAbleToSeeFeature = !!currentPlan?.value?.features?.some(item => item.code === code);
        if (!isAbleToSeeFeature) setPlanPriceDialog(!isAbleToSeeFeature);else router.push(path);
      }
    }
    function filterMenu(menu) {
      return menu.map(item => {
        const hasItemPermission = !item.permissionCode || userRole.value(item.permissionCode);
        if (!hasItemPermission) return null;
        if (item.children) {
          const filteredChildren = filterMenu(item.children);
          if (filteredChildren.length) return {
            ...item,
            children: filteredChildren
          };
        } else if (item.groupTitle) {
          const filteredItems = item.items.filter(child => {
            if (!child.permissionCode) return true;
            return userRole.value(child.permissionCode);
          });
          if (filteredItems.length) return {
            ...item,
            items: filteredItems
          };
        } else if (userRole.value(item.permissionCode) || !item.permissionCode) {
          return item;
        }
        return null;
      }).filter(item => item !== null);
    }
    const filteredMenuList = computed(() => filterMenu(menuList));

    // ── Visual section grouping (no API/routing changes) ──────────────────────
    const sectionIndexMap = {
      '3': 'workspace',
      '4': 'workspace',
      'time-tracking': 'workspace',
      '411': 'workspace',
      '5': 'people',
      '6': 'people',
      '30': 'people',
      '7': 'people',
      '10': 'people',
      '11': 'people',
      'candidates-list': 'people',
      '2': 'admin',
      '12': 'org',
      '16': 'org',
      '17': 'admin',
      '23': 'org',
      '28': 'org',
      'policy': 'admin',
      '29': 'admin'
    };
    const sectionLabels = {
      workspace: 'Workspace',
      people: 'People & Assets',
      org: 'Organization',
      admin: 'Administration'
    };
    const filteredMenuWithSections = computed(() => {
      const result = [];
      let lastSection = undefined;
      for (const item of filteredMenuList.value) {
        const section = sectionIndexMap[item.index] ?? null;
        if (section !== lastSection) {
          lastSection = section;
          if (section && sectionLabels[section]) {
            result.push({
              isSection: true,
              label: sectionLabels[section],
              key: `section-${section}`
            });
          }
        }
        result.push(item);
      }
      return result;
    });

    // ── Active index ──────────────────────────────────────────────────────────
    const flattenMenu = (menuItems = []) => {
      const flattened = [];
      const traverse = items => {
        items.forEach(item => {
          if (!item) return;
          if (item.children && item.children.length) traverse(item.children);
          if (item.groupTitle && Array.isArray(item.items)) traverse(item.items);
          if (item.path && item.index) flattened.push({
            index: item.index,
            path: item.path
          });
        });
      };
      traverse(menuItems);
      return flattened;
    };
    const normalizePath = (path = '') => {
      if (!path || path === '/') return '/';
      return path.replace(/\/+$/, '');
    };
    const activeIndex = computed(() => {
      const flattened = flattenMenu(filteredMenuList.value);
      const currentPath = normalizePath(route.path);
      const matches = flattened.filter(item => {
        const itemPath = normalizePath(item.path);
        return currentPath === itemPath || currentPath.startsWith(`${itemPath}/`);
      });
      if (!matches.length) return '';
      const bestMatch = matches.sort((a, b) => normalizePath(b.path).length - normalizePath(a.path).length)[0];
      return bestMatch?.index ?? '';
    });
    const countVisibleEntries = (groups = []) => {
      return groups.reduce((total, group) => {
        if (!group) return total;
        if (group.groupTitle && Array.isArray(group.items)) return total + group.items.length;
        if (Array.isArray(group.children)) return total + group.children.length;
        return total;
      }, 0);
    };

    // ── Responsive ────────────────────────────────────────────────────────────
    const updateCollapseState = () => {
      if (window.innerWidth < 768) isCollapse.value = false;
    };
    onMounted(() => {
      updateCollapseState();
      window.addEventListener('resize', updateCollapseState);
      const saved = localStorage.getItem('isCollapse') === '1';
      if (saved && window.innerWidth >= 768) toggleSidebar(true);
    });
    onUnmounted(() => {
      window.removeEventListener('resize', updateCollapseState);
    });
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_menu_item = _resolveComponent("el-menu-item");
      const _component_el_sub_menu = _resolveComponent("el-sub-menu");
      const _component_el_menu = _resolveComponent("el-menu");
      return _openBlock(), _createBlock(_component_el_menu, {
        collapse: _unref(isCollapse),
        "default-active": activeIndex.value,
        "background-color": "transparent",
        "text-color": "#c8cadd",
        "active-text-color": "#f38558",
        "collapse-transition": "",
        class: "ck-el-menu"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredMenuWithSections.value, item => {
          return _openBlock(), _createElementBlock(_Fragment, {
            key: item.isSection ? item.key : item.index
          }, [item.isSection ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(item.label), 1)) : item.children && item.children.length && countVisibleEntries(item.children) > 0 ? (_openBlock(), _createBlock(_component_el_sub_menu, {
            key: 1,
            index: item.index
          }, {
            title: _withCtx(() => [_createVNode(_component_el_icon, null, {
              default: _withCtx(() => [_createElementVNode("i", {
                class: _normalizeClass(item.icon)
              }, null, 2)]),
              _: 2
            }, 1024), _createElementVNode("span", _hoisted_2, [_createTextVNode(_toDisplayString(_ctx.$t(item.title)) + " ", 1), _createElementVNode("span", _hoisted_3, [item.showNewBadge ? (_openBlock(), _createElementBlock("span", _hoisted_4, "New")) : _createCommentVNode("", true), item.hasNewFeature ? (_openBlock(), _createElementBlock("i", _hoisted_5)) : _createCommentVNode("", true)])])]),
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, group => {
              return _openBlock(), _createElementBlock(_Fragment, {
                key: group.groupTitle || group.index
              }, [group.groupTitle && group.items && group.items.length ? (_openBlock(), _createElementBlock("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, groupItem => {
                return _openBlock(), _createBlock(_component_el_menu_item, {
                  key: groupItem.index,
                  index: groupItem.index,
                  onClick: $event => handleClickProFeature(groupItem.path, item.hasNewFeature)
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t(groupItem.title)), 1)]),
                  _: 2
                }, 1032, ["index", "onClick"]);
              }), 128))])) : group.children && group.children.length ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                key: 1,
                index: group.index
              }, {
                title: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(group.title), 1)]),
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.children, child => {
                  return _openBlock(), _createBlock(_component_el_menu_item, {
                    key: child.index,
                    index: child.index,
                    onClick: $event => handleClickProFeature(child.path, item.hasNewFeature)
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('menu.' + child.title)), 1)]),
                    _: 2
                  }, 1032, ["index", "onClick"]);
                }), 128))]),
                _: 2
              }, 1032, ["index"])) : _createCommentVNode("", true)], 64);
            }), 128))]),
            _: 2
          }, 1032, ["index"])) : (_openBlock(), _createBlock(_component_el_menu_item, {
            key: 2,
            disabled: item.disabled,
            index: item.index,
            onClick: $event => handleClickProFeature(item.path, item.hasNewFeature)
          }, {
            title: _withCtx(() => [_createElementVNode("span", _hoisted_7, [_createTextVNode(_toDisplayString(_ctx.$t(item.title)) + " ", 1), _createElementVNode("span", _hoisted_8, [item.showNewBadge ? (_openBlock(), _createElementBlock("span", _hoisted_9, "New")) : _createCommentVNode("", true), item.hasNewFeature ? (_openBlock(), _createElementBlock("i", _hoisted_10)) : _createCommentVNode("", true)])])]),
            default: _withCtx(() => [_createVNode(_component_el_icon, null, {
              default: _withCtx(() => [_createElementVNode("i", {
                class: _normalizeClass(item.icon)
              }, null, 2)]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1032, ["disabled", "index", "onClick"]))], 64);
        }), 128))]),
        _: 1
      }, 8, ["collapse", "default-active"]);
    };
  }
};